import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Container, PageHeader } from '@bn-apps/dim-ui-react';
import HelpContent from './HelpContent';
import routes from '@config/routes';
import appStyles from '@/App.module.scss';


const HelpDetailPage = (): JSX.Element => {
    const { t } = useTranslation();
    const { section } = useParams<{ section: string }>();

    // Map URL params to section IDs
    const sectionMap: Record<string, string> = {
        'getting-started': 'gettingStarted',
        'authentication': 'authentication',
        'files': 'files',
        'datasets': 'datasets',
        'map': 'map',
        'tools': 'tools',
        'reports': 'reports',
        'accessibility': 'accessibility',
        'data-lineage': 'dataLineage',
        'data-catalog': 'dataCatalog',
        'tps-mapping': 'tpsMapping',
        'dereferencing': 'dereferencing',
        'definitions': 'definitions',
        'support': 'support',
    };

    const sectionId = section ? sectionMap[section] || 'gettingStarted' : 'gettingStarted';

    return (
        <Container className={appStyles.pageContent}>
            <div className="bn-mbe-800">
                <PageHeader
                    title={t(`help.${sectionId}`)}
                    breadcrumbs={
                        <Breadcrumbs items={[{ label: t('help.title'), href: routes.help }, { label: t(`help.${sectionId}`) }]} />
                    }
                />
            </div>

            <div className="bn-mbs-800">
                <HelpContent section={sectionId} />
            </div>
        </Container>
    );
};

export default HelpDetailPage;
